import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';



//Download ---man search for meaning Ebook!!!
//There's two type of components in react namely 1. Custom Component 2. Simple Component 
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

